import {
  Avatar,
  Button,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
  SwipeableDrawer,
  Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import DialogHeader from '../DialogHeader';
import ViewAssociatedCDMOTeamMembers from './ViewAssociatedCDMOTeamMembers';
import UpdateAssociatedCDMOs from './UpdateAssociatedCDMOs';

const useStyles = makeStyles((theme) => ({
  list: {
    width: '40vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      width: '80vw',
    },
  },
  teamMembers: {
    color: '#286ACF',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    textDecoration: 'underline',
  },
  backdrop: {
    '& .MuiBackdrop-root ': {
      backgroundColor: 'transparent !important',
      opacity: '0 !important',
    },
  },
}));

const ViewAssociatedCDMOs = (props) => {
  const { warehouseDetails } = props;
  const classes = useStyles();
  const [openDialogBox, setDialogBox] = useState({
    open: false,
    type: '',
    parameter: null,
  });

  const handleDialogBox = (type, value) => {
    setDialogBox({
      open: !openDialogBox.open,
      type: type,
      parameter: value,
    });
  };

  const handleCloseDialogBox = () => {
    setDialogBox({
      open: false,
      type: '',
      parameter: null,
    });
  };

  return (
    <React.Fragment>
      <div className={classes.list}>
        <Grid
          container
          justifyContent='center'
          alignItems='center'
          style={{ padding: '1rem' }}
        >
          <Grid item xs={12} sm={12} md={12}>
            <DialogHeader header={'Associated CMOs'} />
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                style={{
                  whiteSpace: 'nowrap',
                  fontSize: '1.5rem',
                  fontWeight: '500',
                  paddingBottom: '10px',
                  justifySelf: 'flex-start',
                }}
              >
                {warehouseDetails.warehouseName}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <List>
                {warehouseDetails.associatedCDMOs.map((org) => (
                  <ListItem key={org.organizationId} alignItems='center'>
                    <ListItemAvatar style={{ margin: 0 }}>
                      <Avatar>{org.organizationName.charAt(0)}</Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography
                          variant='subtitle1'
                          style={{ fontWeight: 500 }}
                        >
                          {org.organizationName}
                        </Typography>
                      }
                      secondary={
                        <Typography
                          className={classes.teamMembers}
                          onClick={() =>
                            handleDialogBox('viewTeamMembers', org)
                          }
                        >
                          {Array.isArray(org.teamMembers)
                            ? `${org.teamMembers.length} team members`
                            : '0 team members'}
                        </Typography>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '1rem',
            alignContent: 'flex-end',
          }}
        >
          <Button
            variant='contained'
            color='secondary'
            style={{ textTransform: 'none' }}
            onClick={() => handleDialogBox('updateCDMOs', warehouseDetails)}
          >
            Update CMOs
          </Button>
        </Grid>
      </div>
      {openDialogBox.open && (
        <SwipeableDrawer
          anchor={'right'}
          open={openDialogBox.open}
          onClose={() => {
            if (openDialogBox.type === 'viewTeamMembers') {
              setDialogBox({
                open: false,
                parameter: null,
              });
            }
          }}
          onOpen={() => handleDialogBox(openDialogBox.type, warehouseDetails)}
          className={classes.backdrop}
        >
          {openDialogBox.type === 'viewTeamMembers' && (
            <ViewAssociatedCDMOTeamMembers
              handleClose={() =>
                setDialogBox({
                  open: false,
                  parameter: null,
                })
              }
              associatedCDMOTeamMember={openDialogBox.parameter}
            />
          )}
          {openDialogBox.type === 'updateCDMOs' && (
            <UpdateAssociatedCDMOs
              warehouseDetails={openDialogBox.parameter}
              handleClose={() => handleCloseDialogBox()}
            />
          )}
        </SwipeableDrawer>
      )}
    </React.Fragment>
  );
};

export default ViewAssociatedCDMOs;
